import React, {Component} from 'react';
import PropTypes from 'prop-types';

import isDate from 'utils/isDate';

import Box from 'components/Box';
import Icon from 'components/Icon';
import Flex from 'components/Flex';
import Time from 'components/Time';
import EasyTooltip from 'components/EasyTooltip';
import OverflowTooltip from 'components/OverflowTooltip';
import {AdminOrHubTextLink} from 'components/AdminOrHubLink';

class StatsList extends Component {
	render() {
		const {data, className} = this.props;

		const rows = data.map(item => {
			let {link} = item;
			const {
				id,
				assetId,
				userId,
				value,
				icon,
				title,
				collectionAsset,
				name,
				date,
				tooltip,
			} = item;

			// If we have a user and no link, generate one.
			if (name && !link) {
				link = `users?search=${name}`;
			}

			const itemId =
				id ||
				assetId ||
				userId ||
				(collectionAsset && collectionAsset.id);

			const label = title || name;

			// Can be a date or arbritrary value
			let dateOrValue;
			if (date) {
				dateOrValue = <Time dateTime={date} />;
			} else if (isDate(value)) {
				dateOrValue = <Time dateTime={value} />;
			} else {
				dateOrValue = value;
			}

			const linkIcon = icon && <Icon name={icon} mr="xxs" />;

			// If an item doesn't have a dedicated tooltip, we show a tooltip
			// of the full item label if it's too long to fit the available space
			const TooltipComponent = tooltip ? EasyTooltip : OverflowTooltip;

			return (
				<Flex
					key={`${itemId ?? label}-${date ?? value}`}
					as="div"
					justifyContent="space-between"
				>
					<TooltipComponent content={tooltip ?? label}>
						<Box as="dt" shrink overflow="ellipsis">
							{link ? (
								<AdminOrHubTextLink link={link}>
									{linkIcon}
									{label}
								</AdminOrHubTextLink>
							) : (
								<>
									{linkIcon}
									{label}
								</>
							)}
						</Box>
					</TooltipComponent>
					<Box as="dd" dimmed overflow="ellipsis">
						{dateOrValue}
					</Box>
				</Flex>
			);
		});

		return (
			<Box as="dl" display="block" fontSize="s" className={className}>
				{rows}
			</Box>
		);
	}
}

StatsList.proptTypes = {
	data: PropTypes.array,
	format: PropTypes.string,
	qaIdContext: PropTypes.string,
};

export default StatsList;
